import React from "react";
import styled from "styled-components";
import hideDataPermissionCheck from "../../controllers/customControllerForCS/hideDataPermissionCheck";

const Container = styled.div`
  padding: 10px 15px;
  padding-right: 40px;
  background-color: var(--surface);
  border-radius: 10px;
  color: var(--element);
  display: flex;
  text-transform: capitalize;
  flex-direction: column;
  gap: 5px;
`;

const Label = styled.div`
  font-size: 12px;
  opacity: 0.65;
  font-weight: 600;
  filter: saturate(0.5);
  color: var(--accent);
`;

const Value = styled.div`
  font-size: 13px;
  /* opacity: 0.5; */
  font-weight: 600;
  color: var(--accent);
`;

export default function BubbleTextForDetailData({ children, permissionName }) {
  let text = nodeToText(children);

  if (text == "Non")
    return (
      <Container>
        <Label>Non</Label>
      </Container>
    );

  let split = text.split(":");

  let value = split[1]?.trim() ? split[1] : "Non";

  value = hideDataPermissionCheck({ permissionName, data: value });

  return (
    <Container>
      <Label>{split[0]?.trim()}</Label>
      <Value>{value}</Value>
    </Container>
  );
}

function nodeToText(node) {
  if (node == null || node === false) return "";
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(nodeToText).join("");
  if (React.isValidElement(node)) return nodeToText(node.props?.children);
  return "";
}
